import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';
import type { IAvailablePaymentMethodsResponse } from '@/modules/perseo-billing/interfaces';
const { AVAILABLE_PAYMENTS_URL } = environment;

async function getBuyNowAvailablePaymentMethods(
  platform: string = 'web'
): Promise<{
  data: IAvailablePaymentMethodsResponse;
}> {
  const url = `${AVAILABLE_PAYMENTS_URL}?platform=${platform}`;
  const response = await httpClient.get<{
    data: IAvailablePaymentMethodsResponse;
  }>(url);
  return {
    data: response?.data?.data
  };
}

export default getBuyNowAvailablePaymentMethods;
